import { formatSeconds } from '~/utils/time';

interface GameScoreProps {
  moves: number;
  movesLabel?: string;
  seconds?: number;
  score: string | number;
}

export function GameScore({ moves, movesLabel = 'Moves', seconds, score }: GameScoreProps) {
  return (
    <>
      <dl className='font-greycliff-bold text-muted-foreground mb-2 grid grid-cols-[1fr_auto] gap-y-2 text-sm'>
        <dt>{movesLabel}</dt>
        <dd className='text-right'>{moves}</dd>
        {seconds && (
          <>
            <dt>Time</dt>
            <dd className='text-right'>{formatSeconds(seconds)}</dd>
          </>
        )}
      </dl>
      <div
        className='my-4 h-1 opacity-75'
        style={{
          backgroundImage: 'url(/svg/squiggle-line.svg)',
          backgroundSize: 'auto 100%',
          backgroundRepeat: 'repeat-x',
        }}
      />
      <dl className='font-greycliff-bold text-foreground mt-2 grid grid-cols-[1fr_auto] text-xl'>
        <dt className='text-muted-foreground'>Score</dt>
        <dd className='text-teal text-right'>{score}</dd>
      </dl>
    </>
  );
}
